import { useContext } from 'react'
import { fireAuth, db } from '../config/firebase'
import { store } from '../store'

export const AuthSignup = () => {
    const { dispatch } = useContext(store)
    return ( email, password ) => {
        return fireAuth.createUserWithEmailAndPassword(email,password)
            .then(({user})=>{
                dispatch({
                    type: 'USER_SIGNIN',
                    email: user.email
                })
                return db.collection('account')
                    .doc(user.email)
                    .set({
                        collections: []
                    })
            })
    }
}

export const AuthSignin = () => (email, password) => fireAuth.signInWithEmailAndPassword(email,password)